
<h2 class="page-heading">Hi Marley Management</h2>
<br>
<app-response-text
    [lambdaMessage]="lambdaMessage"
    [lambdaError]="lambdaError">
</app-response-text>




<div class="table-container">

    <app-mat-data-grid
        [header]="header"
        [(dataSource)]="data"
        [formValid]="formValid"
        [displayedColumns]="['maxCount', 'openedCases', 'closedCases', 'activeCases', 'enabled']"
        [columnNames]="['Max Count', 'Opened Cases', 'Closed Cases', 'Active Cases', 'Enabled']"
        [editDefinition]="{
          'maxCount': maxCount,
          'enabled': enabled
        }"
        [objectBluePrint]="bluePrint"
        (buttonClick)="handleButtonClick($event)"
    >
    </app-mat-data-grid>
</div>

<ng-template #header>
    <span>Texts from Hi Marley will be stopped if disabled.</span>
</ng-template>
<ng-template let-element #enabled>
  <mat-slide-toggle [(ngModel)]="element.enabled"
    >Disable</mat-slide-toggle
  >
</ng-template>
<ng-template let-element #maxCount>
    <input
      type="number"
      placeholder="250"
      [(ngModel)]="element.maxCount"
    >
</ng-template>
<ng-template let-element #openedCases>
  <form [formGroup]="form">
    <textarea
      type="text"
      placeholder="Opened Cases"
      [(ngModel)]="element.opened"
      formControlName="openedCases"
    ></textarea>
  </form>
</ng-template>
<ng-template let-element #closedCases>
  <form [formGroup]="form">
    <textarea
      type="text"
      placeholder="Closed Cases"
      [(ngModel)]="element.closed"
      formControlName="closedCases"
    ></textarea>
  </form>
</ng-template>
<ng-template let-element #activeCases>
  <form [formGroup]="form">
    <textarea
      type="text"
      placeholder="Active Cases"
      [(ngModel)]="element.active"
      formControlName="activeCases"
    ></textarea>
  </form>
</ng-template>